import React from "react";
import { FormattedMessage, MessageDescriptor } from "react-intl";
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@material-ui/core";
import { useStyles } from "./styles";

type Props = {
  title?: MessageDescriptor;
  content?: MessageDescriptor;
  contentValues?: {
    [key: string]: string | number | boolean | Date | JSX.Element | null | undefined;
  };
  actions?: {
    yesMessage?: MessageDescriptor;
    noMessage?: MessageDescriptor;
    handleYes?: () => void;
  };
  handleCloseDialog: () => void;
};

export const ConfirmDialog: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  const { title, content, actions, handleCloseDialog, contentValues } = props;

  return (
    <>
      {title && (
        <DialogTitle>
          <FormattedMessage {...title} />
        </DialogTitle>
      )}
      {content && (
        <DialogContent>
          <DialogContentText color="inherit">
            <FormattedMessage {...content} values={contentValues && contentValues} />
          </DialogContentText>
        </DialogContent>
      )}
      {actions && (
        <DialogActions classes={{ root: classes.dialogActionsRoot }}>
          {actions.yesMessage && (
            <Button
              color="primary"
              variant="contained"
              onClick={(actions && actions.handleYes && actions.handleYes) || handleCloseDialog}
            >
              <FormattedMessage {...actions.yesMessage} />
            </Button>
          )}
          {actions.noMessage && (
            <Button classes={{ root: classes.btnNo }} variant="contained" onClick={handleCloseDialog}>
              <FormattedMessage {...actions.noMessage} />
            </Button>
          )}
        </DialogActions>
      )}
    </>
  );
};
